import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Servicios from './pages/Servicios';
import Llegadas from './pages/llegadas';
import BitacoraPage from './pages/BitacoraPage'; // Importa la página de Bitácora
import GestionPage from './pages/DailyOperatorsInfo';
import Navbar from './components/Navbar';
import FloatingBubbleModal from './components/FloatingBubbleModal';
import FloatingVuelosModal from './components/FloatingVuelosModal';
import ServicioManual from './pages/ServicioManualPage';
import FloatingGestionUsuariosModal from './components/FloatingGestionUsuariosModal';
import { useSelector } from 'react-redux';


// Función para decodificar el JWT
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

// Función para validar el token
const isTokenValid = (token) => {
  if (!token) return false;
  const decoded = parseJwt(token);
  if (!decoded || !decoded.exp) return false;
  return decoded.exp * 1000 >= Date.now();
};


const App = () => {
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = isTokenValid(token);


  const AuthenticatedLayout = ({ children }) => (
    <>
      <Navbar />
      {children}
      <FloatingBubbleModal /> {/* Incluye la burbuja flotante aquí */}
      <FloatingVuelosModal />
      <FloatingGestionUsuariosModal />
    </>
  );

  return (
    <Router>
      <Routes>
        {/* Ruta para el Login */}
        <Route path="/" element={<Login />} />


        {/* Ruta para Servicios */}
        <Route
          path="/servicios"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <Servicios />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Ruta para Llegadas */}
        <Route
          path="/llegadas"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <Llegadas />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Ruta para Llegadas */}
        <Route
          path="/manual"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <ServicioManual />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Ruta para la Bitácora */}
        <Route
          path="/bitacora"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <BitacoraPage />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Ruta para Gestión */}
        <Route
          path="/gestion"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <GestionPage />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Ruta por defecto o no encontrada */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
